<script setup>
    import { router } from '@inertiajs/vue3';
    import { ref } from 'vue';

    // includes we need to front end locale magic
    import { useI18n } from 'vue-i18n';
    // Get locale as set in cookie
    let { locale } = useI18n({ useScope: 'global' });

    const props = defineProps({
        toolkit: Object,
        actions: Array,
        loggedInUserId: Number,
        currentToolkitTeams: Object,
        currentUserTeam: Number,
    });

    function ordinal_suffix_of(i) {
        let j = i % 10;
        let k = i % 100;

        if ( i == 0 ) {
            return i ;
        }
        else {
            if (j == 1 && k != 11) {
            return 'st';
            }
            if (j == 2 && k != 12) {
                return 'nd';
            }
            if (j == 3 && k != 13) {
                return 'rd';
            }
            return 'th';
        }
    }

    const programme = router.page.props.ziggy.programme;
    const organisation = router.page.props.ziggy.organisation;
    const urlNamePrefix = organisation ? "gi." : "";

    const currentToolkitTeams = props.currentToolkitTeams;
    const currentUserTeam = props.currentUserTeam;
    const actions = props.actions;
    const toolkit = props.toolkit;

    let team_custom_name = programme.team_custom_name;
    if (team_custom_name) {
        if(team_custom_name.constructor.name != 'Object') {
            team_custom_name = JSON.parse(team_custom_name);
        }
    }

    let default_team_name;

    if (locale.value == 'cy') {
        default_team_name = 'tîm';

    } else  {
        default_team_name = 'team';
    }

    let team_name = default_team_name;

    if (team_custom_name) {
        team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
    }


    let sortedTeams = '';
    let sortedTeamsTopTen = '';

    function currentTeamClass(teamID) {
        if ( currentUserTeam == teamID ) {
            return 'current-team';
        }
    }

    if (toolkit.scoring == 'Points' ) {
        sortedTeams = currentToolkitTeams.sort((b, a) => a.totalPoints - b.totalPoints);
        sortedTeamsTopTen = sortedTeams.slice(0, 10);
    }
    else {
        sortedTeams = currentToolkitTeams.sort((b, a) => a.totalCompletedActions - b.totalCompletedActions);
        sortedTeamsTopTen = sortedTeams.slice(0, 10);
    }

    let counter = 1;
    sortedTeams.forEach(function (sortedTeam) {
        sortedTeam.rank = counter;
        counter++;
    });

    function displayScore(scoringType, teamTotalActions, TeamTotalPoints) {
        if ( scoringType == 'Actions' ) {
            return teamTotalActions;
        }
        else {
            return TeamTotalPoints;
        }
    }

    function getNearestTeams(teams, givenTeam) {
        let currentTeamIndex = teams.map(teamID => teamID.id).indexOf(givenTeam) -2;
        currentTeamIndex = Math.min(Math.max(0, currentTeamIndex), teams.length - 5);
        return teams.slice(currentTeamIndex, currentTeamIndex + 5);
    }

    // Generate list items for the teams leaderboard.
    function createTeamsList(teamsArray) {
        let currentLeaderboard = document.getElementById('leaderboard-list');
        currentLeaderboard.innerHTML = '';

        teamsArray.forEach(function (team) {
            // Add list element
            const listItem = document.createElement('li');
            currentLeaderboard.appendChild(listItem);
            listItem.classList.add('item','leaderboad-item');
            if ( currentUserTeam == team.id ) {
                listItem.classList.add('current-team');
            }
            // Add outer span element
            const outerSpan = document.createElement('span');
            listItem.appendChild(outerSpan);
            outerSpan.classList.add('flex','items-center');
            // Add span containing leaderboard ranking
            const leaderboardRankWrapper = document.createElement('span');
            outerSpan.appendChild(leaderboardRankWrapper);
            leaderboardRankWrapper.classList.add('leaderboard-rank');
            // Add ranking and ordinal suffix
            const leaderboardRank = document.createElement('span');
            leaderboardRankWrapper.appendChild(leaderboardRank);
            leaderboardRank.innerHTML = team.rank;
            const leaderboardRankOrdinal = document.createElement('sup');
            leaderboardRankWrapper.appendChild(leaderboardRankOrdinal);
            leaderboardRankOrdinal.innerHTML = ordinal_suffix_of(team.rank);
            // Add team name
            const leaderboardTeamName = document.createElement('span');
            leaderboardRankWrapper.after(leaderboardTeamName);
            leaderboardTeamName.classList.add('leaderboard-team-name');
            leaderboardTeamName.innerHTML = team.name;
            // Add team points
            const leaderboardTeamPoints = document.createElement('span');
            outerSpan.after(leaderboardTeamPoints);
            leaderboardTeamPoints.classList.add('leaderboard-points-total');

            // Toolkit scoring is based on points/completed actions
            if (toolkit.scoring == 'Points' ) {
                leaderboardTeamPoints.innerHTML = team.totalPoints;
            }
            else {
                leaderboardTeamPoints.innerHTML = team.totalCompletedActions;
            }

        });
    }

    let leaderboardCheckbox = ref(0);

    const UpdateLeaderboard = () => {
        leaderboardCheckbox ^= true;

        if ( leaderboardCheckbox == 1 ) {
            const teamsList = getNearestTeams(sortedTeams, currentUserTeam);
            createTeamsList(teamsList);
        }
        else {
            createTeamsList(sortedTeamsTopTen);
        }

    }

</script>

<template>
    <div class="dashboard-widget widget leaderboard-widget" v-if="sortedTeams.length">
        <div class="widget-header flex justify-between">
            <span>{{ $t('dashboard.widgets.leaderboard.title') }}</span>
            <span class="material-icons-outlined">emoji_events</span>
        </div>
        <div class="widget-content">
            <p>{{ $t('dashboard.widgets.leaderboard.intro_text') }} {{ team_name }}s.</p>
            <div class="flex items-center mb-5">
                <input
                type="checkbox"
                name="team-position"
                id="team-position"
                @change="UpdateLeaderboard()"
                />
                <label for="team-position" class="text-sm pl-3">{{ $t('dashboard.widgets.leaderboard.position', { team_name: team_name }) }}</label>
            </div>
            <div v-if="sortedTeamsTopTen.length" id="leaderboard-list-wrapper">
                <ul id="leaderboard-list">
                    <li v-for="sortedTeamsTopTenItem in sortedTeamsTopTen" :class="currentTeamClass(sortedTeamsTopTenItem.id)" class="item leaderboad-item">
                        <span class="flex items-center">
                            <span class="leaderboard-rank">
                                <span class="">{{ sortedTeamsTopTenItem.rank }}</span>
                                <sup class="superscript">{{ ordinal_suffix_of(sortedTeamsTopTenItem.rank) }}</sup>
                            </span>
                            <span class="leaderboard-team-name">{{ sortedTeamsTopTenItem.name }}</span>
                        </span>
                        <span class="leaderboard-points-total">{{ displayScore( toolkit.scoring, sortedTeamsTopTenItem.totalCompletedActions, sortedTeamsTopTenItem.totalPoints ) }}</span>
                    </li>
                </ul>
            </div>

            <div v-else id="leaderboard-list">
                <p>{{ $t('dashboard.widgets.leaderboard.empty') }}</p>
            </div>
        </div>
    </div>
</template>
